export default "__VITE_ASSET__CsRmNofj__"